import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { PropType } from '@frontend/sports/common/core/utils/extended-types';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { MarketView, RacingOptionMarketTypes } from '@frontend/sports/racing/feature/models';

@Injectable({
    providedIn: 'root',
})
export class HorsesFixtureTranslationHelper {
    private readonly marketTranslations: PropType<PropType<Sitecore, 'horseRacing'>, 'markets'>;

    constructor(
        sitecore: Sitecore,
        private stringInterpolationPipe: StringInterpolationPipe,
    ) {
        this.marketTranslations = sitecore.horseRacing.markets;
    }

    translateMarketView(market: MarketView): string {
        return this.marketTranslations[market as keyof typeof this.marketTranslations] || '';
    }

    getTranslatedMarketName(marketType: string, places?: string, optionName?: string): string {
        switch (marketType) {
            case RacingOptionMarketTypes.WinEw:
                return this.marketTranslations.WinEW;
            case RacingOptionMarketTypes.BettingWithout:
                return this.stringInterpolationPipe.transform(this.marketTranslations.BettingWithout, {
                    count: optionName!,
                });
            case RacingOptionMarketTypes.ToFinishX: {
                if (places === '2') return this.marketTranslations.ToFinish2;
                else if (places === '3') return this.marketTranslations.ToFinish3;
                else return this.marketTranslations.ToFinish4;
            }
            case RacingOptionMarketTypes.TopX: {
                if (places === '2') return this.marketTranslations.TopFinish2;
                else if (places === '3') return this.marketTranslations.TopFinish3;
                else return this.marketTranslations.TopFinish4;
            }
            case RacingOptionMarketTypes.WinEwExtraPlace:
                const optionNames = optionName!.split(' ');

                return this.stringInterpolationPipe.transform(this.marketTranslations.WinEwExtraplace, {
                    places: optionNames[0],
                    terms: optionNames[1],
                });
            case RacingOptionMarketTypes.Forecast:
                return this.marketTranslations.Forecast;
            case RacingOptionMarketTypes.Tricast:
                return this.marketTranslations.Tricast;
            case RacingOptionMarketTypes.FreeFormed:
                return this.marketTranslations.Specials;
            case RacingOptionMarketTypes.InsuranceX: {
                if (places === '2') return this.marketTranslations.Insurance2Places;
                else if (places === '3') return this.marketTranslations.Insurance3Places;
                else return this.marketTranslations.Insurance4Places;
            }

            case RacingOptionMarketTypes.WinByXlengths: {
                if (places === '1') return this.marketTranslations.WinBy1Lengths;
                else return this.marketTranslations.WinBy3Lengths;
            }
            case RacingOptionMarketTypes.WinnerByHowFar:
                return this.marketTranslations.WinnerByHowFar;

            case RacingOptionMarketTypes.InsideVsOutside:
                return this.marketTranslations.InsideVsOutside;

            case RacingOptionMarketTypes.OddsVsEvens:
                return this.marketTranslations.OddsVsEvens;

            case RacingOptionMarketTypes.TrapWinner:
                return this.marketTranslations.TrapWinner;

            default:
                return marketType;
        }
    }
}
